import { render, staticRenderFns } from "./TranceFinanceDetail.vue?vue&type=template&id=80537f6a&"
import script from "./TranceFinanceDetail.vue?vue&type=script&lang=js&"
export * from "./TranceFinanceDetail.vue?vue&type=script&lang=js&"
import style0 from "./TranceFinanceDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports